import { BACKEND_URL } from "../../../constants";

const URL = `${BACKEND_URL}/graphql`;

const QUERY = `
query (
  $drugNames: [String]!,
  $patientIds: [ID]!,
  $dFirst: Int!,
  $dInclude: Boolean!,
  $pFirst: Int!,
  $pInclude: Boolean!
){
  viewer {
    luDrugs(drugNames: $drugNames, first: $dFirst) @include(if: $dInclude) {
      edges {
        node {
          drugName drugClass
        }
      }
    }
    patients(patientIds: $patientIds, first: $pFirst) @include(if: $pInclude) {
      edges {
        node {
          id
          treatments {
            startDate
            stopDate
            dateMatch
            durationUnknown
            orderUnknown
            regimenName
          }
        }
      }
    }
    lazy
  }
}
`;

export default async function API({
  drugNames,
  patientIds,
}) {
  drugNames = drugNames || [];
  patientIds = patientIds || [];

  const dFirst = drugNames.length;
  const dInclude = drugNames.length > 0;
  const pFirst = patientIds.length;
  const pInclude = patientIds.length > 0;

  const request = new Request(
    URL,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        query: QUERY,
        variables: {
          drugNames: drugNames,
          patientIds: patientIds,
          dFirst: dFirst,
          dInclude: dInclude,
          pFirst: pFirst,
          pInclude: pInclude
        }
      })
    });

  const resp = await fetch(request);
  const {data} =  await resp.json();

  return data;
}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/api.js